<template>
  <pict
    class="book-share__image m-auto"
    block-name="book-share"
    :default="imageProps.default"
    :sources="imageProps.sources"
    :alt="$t('alt')"
  />
</template>

<script>
import Pict from "@/shared/pict"

import imageL from "../images/book-share.png"
import imageL2x from "../images/book-share@2x.png"
import imageS from "../images/book-share_s.png"
import imageS2x from "../images/book-share_s@2x.png"

export default {
  name: "BookShareImage",
  components: {
    Pict
  },
  computed: {
    imageProps() {
      return {
        default: {
          src: imageL,
          srcset: {
            "2x": imageL2x
          }
        },
        sources: [
          {
            media: "s",
            src: imageS,
            srcset: {
              "2x": imageS2x
            }
          }
        ]
      }
    }
  },
  i18n: {
    messages: {
      en: {
        alt: "Illustration of two people lounging on a yellow picnic blanket with white squares and a stack of books in the background, sharing a device and listening together with headphones."
      },
      de: {
        alt: "Illustration von zwei Personen, die auf einer Picknickdecke mit einem Stapel Bücher im Hintergrund entspannen, sich ein Tablet teilen und gemeinsam etwas mit Kopfhörern anhören."
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.book-share {
  ::v-deep &__image {
    width: auto;
  }
}
</style>
